import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row } from 'react-bootstrap';
import Loader from '../../Components/Utility/Loader/Loader';
import { deleteDamFilesByIdAction, fetchDamDeletedFiles, filterSortData } from './store/DAM.action';
import DamListCard from '../../Components/Card/DamListCard/DamListCard';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useDAMModuleState } from './Provider';

function BinFiles() {
  const { t } = useTranslation('common');
  const { damAddEditAccess } = useDAMModuleState([]);
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [state, setState] = useState({
    damList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isArchivedModal: false,
    activeList: 'open',
    folderList: [],
    selectedFolders: [],
    archivedList: [],
    binList: [],
    dragging: false,
  });
  const dispatch = useDispatch();
  const {
    damModule: {
      filterValues: { pageIndex, pageSize, searchText },
      damDeletedFiles,
      totalDeletedCount,
    },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (totalDeletedCount > damDeletedFiles.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damDeletedFiles, totalDeletedCount]);

  useEffect(() => {
    if (Array.isArray(damDeletedFiles)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        binList: damDeletedFiles,
      }));
    }
  }, [damDeletedFiles]);

  useEffect(() => {
    const callFn = async () => {
      setState((prev) => ({ ...prev, loading: true }));
      const params = {
        pageIndex,
        pageSize,
        searchText,
      };
      await dispatch(fetchDamDeletedFiles(params));
      setState((prev) => ({ ...prev, loading: false }));
    };
    callFn();
  }, [dispatch]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalDeletedCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterSortData(obj));
    await dispatch(fetchDamDeletedFiles(params));
  };

  const deleteDam = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damId = [selectedBomLibraryGroupId];
    }

    params.bin = true;

    const res = await dispatch(deleteDamFilesByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));

    setBomId(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      damList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };

    await dispatch(fetchDamDeletedFiles(params));
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  return (
    <div>
      <InfiniteScroll dataLength={state?.binList?.length} next={handlePageNextInScroll} hasMore={state?.hasMore} loader={state?.loading && <Loader />}>
        <div className="container-fluid my-3">
          <Row>
            {state?.binList?.map((item, i) => (
              <DamListCard key={item?._id} item={item} index={i} onDelete={deleteDam} damAddEditAccess={damAddEditAccess} />
            ))}
          </Row>
          {state?.binList?.length === 0 && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
        </div>
      </InfiniteScroll>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE')}
          title="Delete"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
          isFileBin
        />
      )}
    </div>
  );
}

export default BinFiles;
